/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigstory2Inputs */

const en_crosspostingigstory2 = /** @type {(inputs: Crosspostingigstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

const de_crosspostingigstory2 = /** @type {(inputs: Crosspostingigstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

/**
* | output |
* | --- |
* | "Story" |
*
* @param {Crosspostingigstory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigstory2 = /** @type {((inputs?: Crosspostingigstory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigstory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigstory2(inputs)
	return de_crosspostingigstory2(inputs)
});
export { crosspostingigstory2 as "crosspostingIgStory" }